import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// Define a service using a base URL and expected endpoints
export const tripCreatorApi = baseApi.injectEndpoints({
  reducerPath: "tripCreatorApi",
  endpoints: (builder) => ({
    addTripCreator: builder.mutation({
      query: (user) => {
        return {
          url: "trip-category",
          method: "POST",
          body: user,
          headers: {
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["trip"],
    }),
    updateTripCreator: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `trip-category/${id}`,
          method: "PATCH",
          body: data,
          headers: {
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["trip"],
    }),
    deleteTripCreator: builder.mutation({
      query: (id) => {
        return {
          url: `trip-category/${id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["trip"],
    }),
    getAllTripCreator: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `trip-category?${queryParams}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          //   authorization: `Bearer ${getToken()}`,
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["trip"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddTripCreatorMutation,
  useUpdateTripCreatorMutation,
  useDeleteTripCreatorMutation,
  useGetAllTripCreatorQuery, // Add this line to import the query hook
} = tripCreatorApi;
